import { render, staticRenderFns } from "./ImportRotation.vue?vue&type=template&id=01f10464&"
import script from "./ImportRotation.vue?vue&type=script&lang=ts&"
export * from "./ImportRotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports